export const SET_COLLECTION = "SET_COLLECTION";
export const SET_COLLECTIONS = "SET_COLLECTIONS";
export const ADD_COLLECTION = "ADD_COLLECTION";
export const UPDATE_COLLECTION = "UPDATE_COLLECTION";
export const DELETE_COLLECTION = "DELETE_COLLECTION";
